/* eslint-disable
    no-undef,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import OrgConstants from 'constants/OrgConstants'

const OrgActions = Marty.createActionCreators({
  createOrgWithSettings(settings) {
    return this.app.queries.UserQueries.createUserWithEmail(email, password)
  },

  shareSnippet(email, orgId) {
    return this.dispatch(OrgConstants.SHARE_SNIPPET, email, orgId)
  },

  updateOrg(orgId, update) {
    return this.app.queries.OrgQueries.updateOrg(orgId, update)
  }

})

export default OrgActions




// WEBPACK FOOTER //
// ./src/scripts/actions/OrgActions.js